import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResolveCardVerification } from '~/hooks/invoice/useResolveCardVerification';
import { useLocaleKeys } from '~/i18n';
import StripeElementsProvider from '~/providers/StripeElementsProvider';
import styles from '../AdHocInvoiceApproval.module.scss';
import { InvoiceStatusScreen } from '../InvoiceStatusScreen/InvoiceStatusScreen';
export const GetVerificationBranchTID = (parentTestId)=>getTestIds(parentTestId);
export const VerificationBranchTestIds = GetVerificationBranchTID().VerificationBranchTID;
const VerificationBranchInner = (param)=>{
    let { testId, invoiceId, stripeUrl, clientSecret, amount, vendorName, viewInvoiceAction, onResolved } = param;
    const { VerificationBranchTID } = useMemo(()=>GetVerificationBranchTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const verificationTexts = t.invoice.adHocApproval.verificationRequired;
    const { resolve, isResolving, errorMsg } = useResolveCardVerification({
        invoiceId,
        stripeUrl,
        clientSecret,
        onResolved,
        fallbackErrorMessage: verificationTexts.resolveError()
    });
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        className: styles.statusViewRoot,
        children: /*#__PURE__*/ _jsx(InvoiceStatusScreen, {
            testId: VerificationBranchTID.StatusScreen(),
            title: verificationTexts.title(),
            subtitle: verificationTexts.subtitle({
                amount: amount.display(),
                vendorName
            }),
            description: errorMsg || verificationTexts.description(),
            hideLottie: true,
            primaryAction: {
                label: verificationTexts.resolvePayment(),
                onClick: resolve,
                loading: isResolving,
                biName: 'ad_hoc_invoice_resolve_payment'
            },
            secondaryAction: viewInvoiceAction
        })
    });
};
export const VerificationBranch = (props)=>/*#__PURE__*/ _jsx(StripeElementsProvider, {
        children: /*#__PURE__*/ _jsx(VerificationBranchInner, _object_spread({}, props))
    });
